module.exports = __webpack_public_path__ + "img/e25b770.jpg";